// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import styles from './index.scss'
import type {
  UpgradeLink_organization as Organization,
} from './__generated__/UpgradeLink_organization.graphql'

type Props = $ReadOnly<{
  organization: Organization,
}>

function UpgradeLink({organization}: Props): Node {
  const upgradePath = organization.viewer.routes.editAccountPath
  const canShow = organization.onRestrictedPlan && organization.viewerIsAdmin

  if (!canShow)
    return null

  return (
    <div className={styles.upgradeLink}>
      <a
        href={upgradePath}
      >
        {I18n.t('nav.upgrade_to_premium')}
      </a>
    </div>
  )
}

export default (createFragmentContainer(UpgradeLink, {
  organization: graphql`
    fragment UpgradeLink_organization on Organization {
      onRestrictedPlan
      viewerIsAdmin
      
      viewer {
        routes {
          editAccountPath
        }
      }
    }
  `,
}): RelayFragmentContainer<typeof(UpgradeLink)>)
